/* eslint-disable max-len */
import React, { useState } from 'react';
import { Link, Typography, Popover } from '@one-thd/sui-atomic-components';
import { ErrorFilled, WarningFilled, Users } from '@one-thd/sui-icons';
import { INACTIVE_CARD_TOOLTIP_COPY } from '../../utils/consts';
import { isInActive } from '../../utils/general';

interface ICardLabelProps {
  isFailedLoadingBalance?: boolean;
  onlineTransactable?: boolean;
  isLegacyCard?: boolean;
  isPurchaser: boolean;
  isEditable?: boolean;
  onEditLegacy?: () => void;
}

const GiftCardStatusLabel: React.FC<ICardLabelProps> = ({
  onlineTransactable,
  isLegacyCard,
  isFailedLoadingBalance,
  isPurchaser,
  isEditable,
  onEditLegacy
}): JSX.Element | null => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event: { currentTarget: React.SetStateAction<null>; }) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  if (isLegacyCard && isEditable) {
    return (
      <Link
        component="button"
        color="primary"
        variant="h5"
        onClick={onEditLegacy}
        href="#basic-link"
        weight="bold"
        data-testid="open-legacy-edit"
        align="left"
      >
        UPDATE CARD
      </Link>
    );
  }

  if (isFailedLoadingBalance && !isLegacyCard) {
    return (
      <div className="sui-flex">
        <span className="sui-mr-2 sui-flex sui-items-center">
          <ErrorFilled data-testid="tooltip-icon" color="danger" size="small" />
        </span>
        <Typography variant="h5" weight="bold" color="primary">
          Unable to load balance
        </Typography>
      </div>
    );
  }

  if (isPurchaser) {
    return (
      <div className="sui-flex">
        <Typography variant="h5" weight="bold">
          PURCHASER CARD
        </Typography>
        <span className="sui-ml-2 sui-mt-1">
          <Users data-testid="users-icon" size="small" onClick={handleClick} />
        </span>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          placement="bottom"
          title="Purchaser Card"
        >
          <Typography variant="body-xs">
            This card is linked to a purchaser on your account.
          </Typography>
        </Popover>
      </div>
    );
  }

  if (isInActive(isLegacyCard, onlineTransactable)) {
    return (
      <div className="sui-flex">
        <Typography variant="h5" weight="bold" color="primary">
          DISABLED
        </Typography>
        <span className="sui-ml-2 sui-mt-1">
          <WarningFilled data-testid="warning-icon" color="warning" size="small" onClick={handleClick} />
        </span>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          placement="bottom"
          title="Disabled Card"
        >
          <Typography variant="body-xs">{INACTIVE_CARD_TOOLTIP_COPY}</Typography>
        </Popover>
      </div>
    );
  }

  return null;
};

export { GiftCardStatusLabel };
